import store from "@/state/store";
export default [
    {
        path: "/404",
        name: "login",
        component: () => import("../pages/utility/404"),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                if (store.getters["authStore/loggedIn"]) {
                    next({name: "default"});
                } else {
                    next();
                }
            }
        },
    },
    {
        path: "/",
        name: "default",
        meta: {
        },
        component: () => import("../pages/home/home"),
    },
    {
        path: "/chat",
        name: "default",
        meta: {
        },
        component: () => import("../pages/home/chat"),
    },

    {
        path: "/box-chat",
        name: "default",
        meta: {
        },
        component: () => import("../pages/home/boxchat"),
    },
    {
        path: "/thu-tuc-hanh-chinh/chi-tiet/:id?",
        name: "Thủ tục hành chính",
        meta: {},
        component: () => import("../pages/home/thuTucHanhChinh"),
    },

    {
        path: "/chat-boot/chi-tiet/:id?",
        name: "Chat Chi tiết",
        meta: {},
        component: () => import("../pages/home/chat"),
    },

    {
        path: "/chat-mes/chi-tiet/:id?",
        name: "Chat Mes",
        meta: {},
        component: () => import("../pages/home/chatmes"),
    },
    {

        path: "/gioi-thieu",
        name: "default",
        meta: {
        },
        component: () => import("../pages/home/gioithieu"),
    },
    {
        path: "/thong-tin-ca-nhan-cong-dan",
        name: "Người dùng",
        meta: {},
        component: () => import("../pages/congdan/user"),
    },
    {
        path: "/lich-su-cua-toi",
        name: "Lịch sử của tôi",
        meta: {},
        component: () => import("../pages/home/lichsucuatoi"),
    },
    {
        path: "/danh-sach-dich-vu-cong",
        name: "default",
        meta: {
        },
        component: () => import("../pages/home/danhSachDichVuCong.vue"),
    },
    {
        path: "/hoi-dap",
        name: "default",
        meta: {
        },
        component: () => import("../pages/home/hoidap"),
    },
    {
        path: "https://paht.dongthap.gov.vn/tao-phan-anh",
        name: "default",
        meta: {
        },
        component: () => import("../pages/home/hoidap"),
    },
    {
        path: "/lich-su",
        name: "default",
        meta: {
        },
        component: () => import("../pages/home/lichsu"),
    },
    {
        path: "/tai-khoan",
        name: "default",
        meta: {
        },
        component: () => import("../pages/quantri/user"),
    },
    {
        path: "/tai-khoan-cong-dan",
        name: "default",
        meta: {
        },
        component: () => import("../pages/quantri/userCongDan"),
    },
    {
        path: "/menu",
        name: "default",
        meta: {
        },
        component: () => import("../pages/quantri/menu"),
    },

    {
        path: "/nhom-quyen",
        name: "Quản lý nhóm quyền",
        meta: {},
        component: () => import("../pages/quantri/module"),
    },
    {
        path: "/vai-tro",
        name: "Quyền",
        meta: {},
        component: () => import("../pages/quantri/unitRole"),
    },
    {
        path: "/vai-tro/thiet-lap-quyen/:id?",
        name: "Vai trò",
        meta: {},
        component: () => import("../pages/quantri/unitRole/addPermissions"),
    },
    {
        path: "/nhom-quyen/action/:id?",
        name: "Hành động",
        // meta: {},
        component: () => import("../pages/quantri/module/action"),
    },
    {
        path: "/thong-tin",
        name: "Thông tin trang",
        meta: {},
        component: () => import("../pages/quantri/thongtintrang"),
    },
    {
        path: "/don-vi",
        name: "Đơn vị",
        meta: {},
        component: () => import("../pages/quantri/donvi"),
    },
    // {
    //     path: "/lich-su-giao-dich",
    //     name: "Lịch sử",
    //     meta: {},
    //     component: () => import("../pages/quantri/logging"),
    // },
    {
        path: "/muc-do",
        name: "Mức độ",
        meta: {},
        component: () => import("../pages/quantri/mucdo"),
    },

    {
        path: "/linh-vuc",
        name: "Lĩnh vực",
        meta: {},
        component: () => import("../pages/quantri/linhvuc"),
    },

    {
        path: "/don-vi",
        name: "Lĩnh vực",
        meta: {},
        component: () => import("../pages/quantri/donvi"),
    },
    {
        path: "/lich-su-hoi-dap",
        name: "Lịch sử giao dịch",
        meta: {},
        component: () => import("../pages/quantri/lichsugiaodich"),
    },
    {
        path: "/loai-ung-dung",
        name: "Loại ứng dựng",
        meta: {},
        component: () => import("../pages/quantri/loaiungdung"),
    },
    {
        path: "/danh-sach-thu-tuc-hanh-chinh",
        name: "Danh sách thủ tục hành chính",
        meta: {},
        component: () => import("../pages/quantri/dsthutuchanhchinh"),
    },
    {
        path: "/thu-tuc-hc/chi-tiet/:id?",
        name: "Thủ tục hành chính",
        meta: {},
        component: () => import("../pages/quantri/dsthutuchanhchinh/thuTucHC"),
    },
    {
        path: "/thong-tin-ca-nhan",
        name: "Thông tin cá nhân",
        // meta: {},
        component: () => import("../pages/taikhoan/profile"),
    },
    {
        path: "/dashboard",
        name: "Dashboard",
        // meta: {},
        component: () => import("../pages/quantri/dashboard"),
    },
    {
        path: "/404",
        name: "404",
        component: require("../pages/utility/404").default,
    },
    {
        path: "/unauthorized",
        name: "401",
        component: require("../pages/utility/401").default,
    },
    {
        path: "*",
        redirect: "404",
    },
    {
        path: "/ngu-canh",
        name: "Ngữ cảnh",
        meta: {},
        component: () => import("../pages/quantri/ngucanh/index"),
    },
    {
        path: "/ngu-canh/cau-hoi/:id?",
        name: "DANH SÁCH BỘ CÂU HỎI - TRẢ LỜI",
        meta: {},
        component: () => import("../pages/quantri/ngucanh/cauHoi"),
    },
    {
        path: "/chat-dich-vu-cong",
        name: "DANH SÁCH BỘ CÂU HỎI - TRẢ LỜI",
        meta: {},
        component: () => import("../pages/home/chatdichvucong"),
    },
    {
        path: "/chat-phan-anh-hien-truong",
        name: "DANH SÁCH BỘ CÂU HỎI - TRẢ LỜI",
        meta: {},
        component: () => import("../pages/home/chatphananhhientruong"),
    },

    {
        path: "/danh-sach-danh-gia",
        name: "Danh sách đánh giá",
        meta: {},
        component: () => import("../pages/quantri/danhsachdanhgia"),
    },

    {
        path: "/quan-ly-file",
        name: "Quản lý file",
        meta: {},
        component: () => import("../pages/quantri/quanlyfile"),
    },

]
